import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PREPROD_PREVIEW_ACTIONS } from './types';
export var embedContextReducer = function embedContextReducer(state, action) {
  switch (action.type) {
    case PREPROD_PREVIEW_ACTIONS.SET_IS_IFRAME_VISIBLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        iframeState: _objectSpread(_objectSpread({}, state.iframeState), {}, {
          isIframeVisible: action.payload
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_BOARD_STATUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        boardState: _objectSpread(_objectSpread({}, state.boardState), {}, {
          boardStatus: action.payload
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        boardContainerState: _objectSpread(_objectSpread({}, state.boardContainerState), {}, {
          boardContainerDisplayMode: action.payload
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        iframeConfig: _objectSpread(_objectSpread({}, state.iframeConfig), action.payload)
      });

    case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_REF:
      return _objectSpread(_objectSpread({}, state), {}, {
        iframeState: _objectSpread(_objectSpread({}, state.iframeState), {}, {
          iframeRef: action.payload
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_IFRAME_READY:
      return _objectSpread(_objectSpread({}, state), {}, {
        iframeState: _objectSpread(_objectSpread({}, state.iframeState), {}, {
          isIframeReady: action.payload
        })
      });

    case PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        boardContainerState: _objectSpread(_objectSpread({}, state.boardContainerState), {}, {
          boardContainerDisplayMode: !state.boardContainerState.boardContainerDisplayMode || state.boardContainerState.boardContainerDisplayMode === 'inline' ? 'modal' : 'inline'
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_EDITABLE_TEMPLATES_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        boardContainerState: _objectSpread(_objectSpread({}, state.boardContainerState), {}, {
          editableTemplates: _objectSpread(_objectSpread({}, state.boardContainerState.editableTemplates), action.payload)
        })
      });

    case PREPROD_PREVIEW_ACTIONS.SET_IS_BOARD_ACTIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        boardContainerState: _objectSpread(_objectSpread({}, state.boardContainerState), {}, {
          editableTemplates: _objectSpread(_objectSpread({}, state.boardContainerState.editableTemplates), {}, {
            isEditableTemplateBoardActive: action.payload
          })
        })
      });

    default:
      return state;
  }
};